<template>
  <div class="title-menu-box">
    <div class="menu-box1">
      <span class="pointer" @click="toUrl(menuObj.path1)">
        <span>{{menuObj.title1}}</span>
        <div class="line" v-show="$path==menuObj.path1"></div>
      </span>
      <span class="pointer" @click="toUrl(menuObj.path2)">
        {{menuObj.title2}}
        <div class="line" v-show="$path==menuObj.path2"></div>
      </span>
      <span class="pointer" v-if="menuObj.path3" @click="toUrl(menuObj.path3)">
        {{menuObj.title3}}
        <div class="line" v-show="$path==menuObj.path3"></div>
      </span>
      <span class="pointer" v-if="menuObj.path4" @click="toUrl(menuObj.path4)">
        {{menuObj.title4}}
        <div class="line" v-show="$path==menuObj.path4"></div>
      </span>
    </div>
  </div>
</template>
<script>
export default {
    props:{
        menuObj:{
            type:Object,
            default:{}
        }
    },
  data() {
    return {
        menuList:{}
    };
  },
  mounted() {
    window.that = this;
  },
  methods: {
    toUrl(path) {
      that.$router.push(
        {
          path,
        },
        () => {}
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.title-menu-box {
  position: relative;
  width: 100%;
  height: 0.6rem;
  .menu-box1{
    width: 100%;
    height: 100%;
    background: #EEEEEE;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  span {
    position: relative;
    display: block;
    width: 2rem;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.2rem;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    color: #000000;
    z-index: 1;
    .line{
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      width: 0.86rem;
      height: 0.02rem;
      background: #EF0000;
    }
  }
}
@media screen and (max-width: 768px){
  .title-menu-box {
    height: 0.4rem;
    .menu-box1{
      .pointer{
        width: 25%;
        box-sizing: border-box;
        font-size: 0.15rem;
        font-family: Microsoft YaHei;
        span{
          font-size: 0.15rem;
          font-family: Microsoft YaHei;
        }
        .line{
          width: 0.6rem;
          height: 1px;
        }
      }
    }
  }
}
</style>